<template>
    <div class="w-full px-12 mt-48 xs:w-1/2 sm:w-1/3">
        <!--    CARD START-->
        <div>
            <div class="flex items-center">
                <div class="flex items-center justify-center flex-shrink-0 w-48 h-48 bg-yellow-200 rounded-full">
                    <div class="flex-shrink-0 block w-24 h-24 fill-current text-primary">
                        <IconContactSVG class="w-24 h-24"/>
                    </div>
                </div>

                <span class="ml-12 font-normal title-lg text-primary">{{ $t('info.contractual_info') }}</span>
            </div>

            <span v-if="customerInfo.contract_details.agreement_date"
                  class="mt-16 self-label">{{ $t('info.credit_limit_valid_from') }}</span>
            <span v-if="customerInfo.contract_details.agreement_date"
                  class="text-base font-semibold sm:text-md">{{ formatDate(customerInfo.contract_details.agreement_date) }}</span>

            <span v-if="customerInfo.contract_details.total_credit_limit"
                  class="mt-16 self-label">{{ $t('info.credit_amount') }}</span>
            <span v-if="customerInfo.contract_details.total_credit_limit" class="text-base font-semibold sm:text-md">{{
                    formatSum(customerInfo.contract_details.total_credit_limit)
                }}</span>

            <span v-if="customerInfo.contract_details.payment_due_days"
                  class="mt-16 self-label">{{ $t('info.payment_terms') }}</span>
            <span v-if="customerInfo.contract_details.payment_due_days"
                  class="text-base font-semibold sm:text-md">{{ customerInfo.contract_details.payment_due_days }}</span>

            <button v-if="customerInfo.customertype === 'P'" data-open-modal="lepinguline_info" class="mt-16 self-btn-plain">
      <span class="w-16 ml-0 mr-4 self-btn-plain__icon">
          <IconPencilSVG/>
      </span>
                <span class="self-btn-plain__text">{{ $t('info.modify') }}</span>
            </button>
        </div>
        <!--    CARD END-->

        <!--    MODAL START-->
        <div class="micromodal" id="lepinguline_info" aria-hidden="true">
            <div class="px-10 micromodal__overlay" tabindex="-1">
                <div class="micromodal__container" role="dialog" aria-modal="true" aria-labelledby="modal-title">
                    <header class="micromodal__header">
                        <h2 class="pb-24 pr-48 title-2xl text-primary">{{ $t('info.edit_contractual_info') }}</h2>

                        <button class="micromodal__close" aria-label="Close modal" data-micromodal-close>
                <span class="flex-shrink-0 block w-20 h-20 text-black pointer-events-none fill-current">
                    <IconXSVG/>
                </span>
                        </button>
                    </header>
                    <div class="micromodal__content">
                        <div class="flex self-form-wrap">
                            <div class="w-full self-form-wrap-item">
                                <label class="e5-form-label" for="kategooria">Kliendi kategooria</label>
                                <div class="relative">
                                    <div class="self-form-select-wrap">
                                        <select name="kategooria" id="kategooria" class="e5-select">
                                            <option selected value="kategooria_nimetus">Kategooria nimetus</option>
                                            <option value="esimene">Esimene kategooria</option>
                                            <option value="teine">Teine kategooria</option>
                                            <option value="kolmas">Kolmas kategooria</option>
                                            <option value="neljas">Neljas kategooria</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="w-full self-form-wrap-item">
                                <label class="e5-form-label" for="krediidilimiit">Krediidilimiit kehtiv alates</label>
                                <div class="relative">
                                    <input type="text" id="krediidilimiit" placeholder="" name="krediidilimiit"
                                           value="01.09.2023" class="e5-input">
                                </div>
                            </div>

                            <div class="w-full self-form-wrap-item">
                                <label class="e5-form-label" for="krediidi_summa">Krediidi summa</label>
                                <div class="relative">
                                    <input type="text" id="krediidi_summa" placeholder="" name="krediidi_summa"
                                           value="5000 €" class="e5-input">
                                </div>
                            </div>

                            <div class="w-full self-form-wrap-item">
                                <label class="e5-form-label" for="makset">Maksetähtaeg</label>
                                <div class="relative">
                                    <input type="text" id="makset" placeholder="" name="makset" value="30 päeva"
                                           class="e5-input">
                                </div>
                            </div>

                            <div class="flex items-center justify-between w-full px-8 pt-16">
                                <div>
                                    <button class="self-btn-primary">
                                        Salvesta

                                        <span class="text-yellow-300 self-btn-primary__icon">
                      <IconArrowAltSVG/>
                    </span>
                                    </button>
                                </div>

                                <div>
                                    <button data-micromodal-close="" class="self-btn-plain">
                      <span class="w-16 ml-0 mr-4 self-btn-plain__icon">
                          <IconXSVG/>
                      </span>
                                        <span class="self-btn-plain__text">Tühista</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <!--    MODAL END-->

    </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import IconPencilSVG from '@/assets/static/icons-src/icon-pencil.svg'
import IconXSVG from '@/assets/static/icons-src/icon-x.svg'
import IconArrowAltSVG from '@/assets/static/icons-src/icon-arrow-alt.svg'
import IconContactSVG from '@/assets/static/icons-src/icon-contact.svg'
import { ICustomer } from '@/domain/ICustomer'
import UtilsMixin from '@/scripts/utils'

@Component({
    components: {
        IconPencilSVG,
        IconXSVG,
        IconArrowAltSVG,
        IconContactSVG
    },
    mixins: [UtilsMixin]
})
export default class ContractualInformation extends Vue {
    get customerInfo (): ICustomer {
        return this.$store.getters.getCustomerInfo
    }
}
</script>

<style scoped>

</style>
